import { createActionId, sessionRecord } from '../platform/session/session';
import { emit } from '../platform/events/lifecycle';
import { getCanonicalPageType } from './utils/window-utils';
import { MAGIC_APRON_ASSISTANT_ORIGIN, EXTERNAL_ENTRY } from './assistant-config';

// The shape analytics parses out of `submit-click`, shared by both producers:
//   maa:<entry location>:<page type>:<message origin>:<question>
export const buildAnalyticsQuestion = ({
  entryLocation, pageType, messageOrigin, userQuestion,
}) => [
  MAGIC_APRON_ASSISTANT_ORIGIN,
  entryLocation,
  pageType,
  messageOrigin,
  userQuestion,
].filter(Boolean).join(':');

export const emitExternalEntryClick = (
  interactionLabel,
  entryLocation = EXTERNAL_ENTRY.DEFAULT_ENTRY_LOCATION,
) => {
  const { sessionId } = sessionRecord.get() ?? {};
  emit(EXTERNAL_ENTRY.SUBMIT_EVENT, {
    actionID: createActionId(sessionId),
    sessionID: sessionId,
    question: buildAnalyticsQuestion({
      entryLocation,
      pageType: String(getCanonicalPageType()).toLowerCase(),
      messageOrigin: EXTERNAL_ENTRY.MESSAGE_ORIGIN,
      userQuestion: interactionLabel,
    }),
  });
};
